// extracted by mini-css-extract-plugin
export default {"wrapper":"InputEdge_wrapper__4rG8S","input":"InputEdge_input__h8nY5","button":"InputEdge_button__HQ0OA"};